module.exports = __webpack_public_path__ + "static/img/UpDateStatus.453ab56.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/UpDateStatus.png
// module id = 4kFi
// module chunks = 3